/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import * as Config from "./config";

async function reqCeritificaciones() {    
	const API_URI_CERTIFICACIONES = Config.certificacionesRoute;
    const response = await axios.get(API_URI_CERTIFICACIONES);    
    return response.data;    
}

export default {
    reqCeritificaciones
};
